import React, { useMemo } from 'react';
import CardCommon from '@op/components/CardCommon';
import useIntls from '@opm/hooks/useIntls';
import VideoCard from '@opm/pages/Videos/components/videoCard';
import "./index.scss"
import TextClamp from '@opm/components/TextClamp';

interface IDouyinHashtagDetailProps {
    data: any;
    onClose: () => void;
}

/** 将原始 API 数据转换为 VideoCard 所需格式 */
function toVideoCardData(raw: any) {
    return {
        url: raw.video_url,
        cover: raw.video_cover,
        video_title: raw.video_title,
        video_title_en: raw.video_title,
        video_title_zh: raw.video_title,
        views: raw.view_count,
        likes: raw.like_count,
        comments: raw.comment_count,
        duration: raw.video_duration,
        channel: 'douyin',
        username: raw.author_name,
        time: raw.publish_time,
    };
}

export default function DouyinHashtagDetail({
    data,
    onClose,
}: IDouyinHashtagDetailProps) {
    const { intl, isEn } = useIntls();

    const {text: title, isEmpty} = useMemo(() => {
        if(!data) return {text: "-", isEmpty: true};
        const mainText = isEn ? data.hashtag_en || data.hashtag : data.hashtag;
        const isEmpty = !data.top_videos || data.top_videos.length === 0;

        if (!mainText) return {text: '-', isEmpty}; 
        return {text: mainText, isEmpty}
    }, [data, intl])

    if (!data) return null;

    

    return (
        <CardCommon
            className="dbom-douyin-hashtag-detail"
            title={<TextClamp rowNum={2} text={title} placement="top" />}
            hasDownload
            downloadIcon="clonse"
            downLoadTips={intl('Close')}
            handleDownloadOnClick={onClose}
            empty={isEmpty}
            hasEmptyImg={false}
            hasEmptyDesc={false}
        >
            {!isEmpty && (
                <div className="dbom-video-list">
                    {data.top_videos.map((item: any) => (
                        <VideoCard
                            key={item.video_id}
                            item={toVideoCardData(item)}
                            language="origin"
                            hideKeys={["views"]}
                        />
                    ))}
                </div>
            )}
        </CardCommon>
    );
}
